import React from 'react';
// import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './src/theme';
import { ThemeContextProvider } from './src/themeContext/ThemeContext';
import './src/style/global.css';
import i18n from './src/i18n/index';
import { I18nextProvider } from 'react-i18next';

export const wrapRootElement = ({ element }) => (
  <ThemeContextProvider theme={theme}>
    <I18nextProvider i18n={i18n}>
      <CssBaseline />
      {element}
    </I18nextProvider>
  </ThemeContextProvider>
);

export const onClientEntry = () => {
  const link = document.createElement('link');
  link.href =
    'https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sora:wght@100;200;300;400;500;600;700;800&family=Lily+Script+One&family=Satisfy&display=swap';
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};
